export default __webpack_public_path__ + "static/media/client.48e1e4fd.jpg";